import React, { useEffect, useRef, useState } from "react";
import { CSVLink } from "react-csv";
import styles from "../../assets/styles/salesSlotBooking.module.css";
import EditIconsSvg from "../../assets/images/edit-icon.svg";
import logsIconSvg from "../../assets/images/hamburger.svg";
import downIcon from "../../assets/images/cst-download.svg";
import downloadIcon from "../../assets/images/angle_right.svg";
import DeleteIconSvg from "../../assets/images/delete_icon.svg";
import hamburger from "../../assets/images/hamburger.svg";
import AsyncSelect from "react-select/async";
import config from "../../config";
import CryptoJS from "crypto-js";
import {
  SlDrawer,
  SlOption,
  SlSelect,
  SlInput,
  SlButton,
  SlIcon,
} from "@shoelace-style/shoelace/dist/react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import {
  format,
  addMonths,
  subMonths,
  addWeeks,
  subWeeks,
  addDays,
  subDays,
  isBefore,
  isAfter,
  isSameMonth,
  isSameWeek,
  isSameDay,
  differenceInDays,
  set,
  getDaysInMonth,
  eachDayOfInterval,
  startOfMonth,
  endOfMonth,
} from "date-fns";
import Select from "react-select";
import Datepicker from "react-tailwindcss-datepicker";
import { Toast } from "../../shared/Toast";
import durationClockSvg from "../../assets/images/duration-clock.svg";
import downloadIconSvg from "../../assets/images/download-icon-big.svg";
import approveSvg from "../../assets/images/approve-icon.svg";
import closeCrossIconSvg from "../../assets/images/close_cross_icon.svg";
import searchIconSvg from "../../assets/images/Search.svg";
import verifyRoSvg from "../../assets/images/verify-ro.svg";
import rejectSvg from "../../assets/images/reject-icon.svg";
import closeSvg from "../../assets/images/uncheck.svg";
import angleRightSvg from "../../assets/images/angle_right.svg";
import TableLoader from "../../shared/TableLoader";
import NoDataFound from "../../shared/NoDataFound";
import calendarSvg from "../../assets/images/calendar.svg";
import prevArrowSvg from "../../assets/images/prev-arrow.svg";
import nextArrowSvg from "../../assets/images/next-arrow.svg";
import MonthlyCalendar from "./MonthlyCalendar";
import viewIconSvg from "../../assets/images/view_icon.svg";
import filterIconSvg from "../../assets/images/filter_icon.svg";
import addPlusIconSvg from "../../assets/images/add_plus_icon-wht.svg";
import verticalViewSvg from "../../assets/images/vertical_view.svg";
import activityViewIconSvg from "../../assets/images/activity-icon-wht.svg";
import WeeklyCalendar from "./WeeklyCalendar";
import BookSlot from "./BookSlot";
import ToogleLeftSvg from "../../assets/images/toggle-angle-left.svg";
import ToogleRightSvg from "../../assets/images/toggle-angle-right.svg";

import AddPlusWhiteSvg from "../../assets/images/add_plus_icon-wht.svg";
import { SetComponentId } from "../../redux/counterSlice";
import API from "../../services/api";
import {
  billingOptions,
  BrandsTypes,
  capitalizeFirstLetter,
  defaultValue,
  getGenerateUrl,
  getNumberOfDays,
  langoptions_preview,
  languageOptions,
  stateOptions as mainStateOptions,
  roles,
  slotBookingCreativeTypes,
  slotPackagesOptions,
  slotPaymentMethodOptions,
  slotPaymentTypeOptions,
  slotPositions,
  slotStatusOptions,
} from "../../utils/constants";
import {
  formatDateDDMMYYY,
  formatDateWithTime,
  formatDateYYYYMMDD,
  ISODateString,
} from "../../utils/dateFormat";
import SlotModelView from "./DateWiseSlots";
import { debounce, debouncePromise } from "../../utils/Debounce";
import UserActivity from "./UserActivity";
import { useNavigate } from "react-router";
import SlotVIew from "./SlotVIew";
import SlotHistory from "./SlotHistory";
let weekDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

function SalesSlotBooking() {
  const dispatch = useDispatch();
  dispatch(SetComponentId(52));
  const navigate = useNavigate();
  let salesUserType = "";
  let now = new Date();
  now.setHours(0, 0, 0, 0);
  if (
    localStorage.getItem("role") === roles.salesperson &&
    localStorage.getItem("salesTabFlag")
  ) {
    const decryptedSalesTabPermissions = CryptoJS.AES.decrypt(
      localStorage.getItem("salesTabFlag"),
      config.B2B_SECRET_KEY
    );
    salesUserType = decryptedSalesTabPermissions.toString(CryptoJS.enc.Utf8);
  }
  const salesUsersList = useSelector((state) => state.Head.subordinates);
  const [initialRender, setInitialRender] = useState(true);
  const [currentDate, setCurrentDate] = useState(now);
  const [loader, setLoader] = useState(false);
  const [bookSlotModalOpen, setBookSlotModalOpen] = useState(false);
  const [deleteSlotData, setDeleteSlotData] = useState({});
  const [editItem, setEditItem] = useState(null);
  const [data, setData] = useState([]);
  const [weekNumber, setWeekNumber] = useState(0);
  const [showActivity, setShowActivity] = useState(false);
  const currentMonth = format(currentDate, "MMMM"); // August, etc.
  const currentYear = format(currentDate, "yyyy"); // 2024, etc.
  const [sales_id, setSales_id] = useState(0);
  const [salesList, setSalesList] = useState([]);
  const [assignedBrands, setAssignedBrands] = useState([]);
  const [initialAssignedBrands, setInitialAssignedBrands] = useState([]);
  const [mostActive, setMostActive] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [filterBrand_id, setFilterBrand_id] = useState(-1);
  const [filterDateRange, setFilterDateRange] = useState({
    startDate: now,
    endDate: now,
  });
  const [searchText, setSearchText] = useState("");
  const [statusFilter, setStatusFilter] = useState(0);
  const [positionFilter, setPositionFilter] = useState(0);
  const [langFilter, setLangFilter] = useState(1);
  const [stateFilter, setStateFilter] = useState(-1);
  const [districtFilter, setDistrictFilter] = useState(-1);
  const [constituencyFilter, setConstituencyFilter] = useState(-1);
  const [headApproveFilter, setHeadApproveFilter] = useState(false);
  const [stateOptions, setStateOptions] = useState([
    { label: "Select State", value: -1 },
    ...mainStateOptions
      .filter((item) => item.lang_id === 1)
      .map((item) => {
        return { label: item.state_name, value: item.state_id };
      }),
  ]);
  const [districtOptions, setDistrictsOptions] = useState([]);
  const [constituencyOptions, setConstituencyOptions] = useState([]);
  const [headerVisible, setHeaderVisible] = useState(window.innerWidth <= 767 ? false : true);
  const [modelViewDateRange, setModelViewDateRange] = useState(null);
  const [monthView, setMonthView] = useState(
    localStorage.getItem("role") === roles.ops || salesUsersList.length > 1
      ? false
      : true
  );
  const [newUserTypeFilter, setNewUserTypeFilter] = useState(0);
  const [creativeTypeFilter, setCreativeTypeFilter] = useState("");
  const [campaignTypeFilter, setCampaignTypeFilter] = useState("");
  const [billingTypeFilter, setBillingTypeFilter] = useState("");
  const [paymentMethodFilter, setPaymentMethodFilter] = useState("");
  const [slotView_id, setSlotView_id] = useState(null);
  const [slotLog_id, setSlotLog_id] = useState(null);
  const [downloadData, setDownloadData] = useState([])
  const [downloadLoader, setDownloadLoader] = useState(false)
  const downloadRef = useRef(null)

  //Finance consts
  const [bookingId, setBookingId] = useState(null);
  const [showPdfArray, setShowPdfArray] = useState([]);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const rejectForm = useForm({ mode: "all" });
  const selectedReasons = rejectForm.watch("reason", []);

  // Validation function
  const validateReasons = () => {
    return selectedReasons.length > 0;
  };

  const handlePrevMonth = () => setCurrentDate(subMonths(currentDate, 1));
  const handleNextMonth = () => setCurrentDate(addMonths(currentDate, 1));

  const handlePrevClick = () => {
    setFilterDateRange({
      startDate: subMonths(filterDateRange?.startDate, 1),
      endDate: subMonths(filterDateRange?.startDate, 1),
    });
    handlePrevMonth();
  };
  const handleNextClick = () => {
    setFilterDateRange({
      startDate: addMonths(filterDateRange?.startDate, 1),
      endDate: addMonths(filterDateRange?.startDate, 1),
    });
    handleNextMonth();
  };

  const getSlotsData = async () => {
    try {
      setLoader(true);
      const result = await API({
        url: "/slotbooking/get-booking-data",
        method: "POST",
        data: {
          currentDate,
          dateRange:
            filterDateRange.startDate && !monthView
              ? filterDateRange
              : undefined,
          sales_id,
          brand_id: filterBrand_id !== -1 ? filterBrand_id : undefined,
          lang_id: langFilter !== -1 ? langFilter : undefined,
          state_id: stateFilter !== -1 ? stateFilter : undefined,
          district_id: districtFilter !== -1 ? districtFilter : undefined,
          const_id: constituencyFilter !== -1 ? constituencyFilter : undefined,
          searchText: searchText ? searchText : undefined,
          positionFilter: positionFilter ? positionFilter : undefined,
          statusFilter: statusFilter ? statusFilter : undefined,
          headApproveFilter: headApproveFilter ? headApproveFilter : undefined,
          newUserTypeFilter: newUserTypeFilter ? newUserTypeFilter : undefined,
          creativeTypeFilter: creativeTypeFilter
            ? creativeTypeFilter
            : undefined,
          campaignTypeFilter: campaignTypeFilter
            ? campaignTypeFilter
            : undefined,
          billingTypeFilter:
            billingTypeFilter !== "" ? billingTypeFilter : undefined,
          paymentMethodFilter:
            paymentMethodFilter !== "" ? paymentMethodFilter : undefined,
        },
        responseType: "json",
      });
      if (result.code === 200) {
        setData(result.data);
        setInitialRender(false);
      }
      setLoader(false);
      if (result.status === 401) navigate("/");
    } catch (error) {
      console.error("Error @ getSlotsData", error);
      if (error.response.status === 401) navigate("/");
    }
  };
  useEffect(() => {
    if (!initialRender) getSlotsData();
  }, [
    currentDate,
    sales_id,
    filterBrand_id,
    searchText,
    positionFilter,
    statusFilter,
    headApproveFilter,
    langFilter,
    filterDateRange,
    stateFilter,
    districtFilter,
    constituencyFilter,
    newUserTypeFilter,
    creativeTypeFilter,
    campaignTypeFilter,
    billingTypeFilter,
    paymentMethodFilter,
  ]);

  useEffect(() => {
    setEditItem(null);
    if (
      !bookSlotModalOpen &&
      !modelViewDateRange &&
      !initialRender &&
      !slotView_id &&
      !slotLog_id
    ) {
      getSlotsData();
    }
  }, [bookSlotModalOpen, modelViewDateRange, slotView_id, slotLog_id]);
  useEffect(() => {
    getSlotsData();
  }, []);

  const getWeekNumber = async () => {
    try {
      const result = await API({
        url: "/slotbooking/get-week-number",
        method: "POST",
        responseType: "json",
        body: { lang_id: langFilter !== -1 ? langFilter : undefined },
      });
      if (result.code === 200) {
        setWeekNumber(result.data);
      }
      if (result.status === 401) navigate("/");
    } catch (error) {
      console.error("Error @ getWeeksSlotNumber", error);
    }
  };

  const getWeekData = async () => {
    try {
      setSales_id(0);
      setCurrentDate(new Date());
      resetFilter();
    } catch (error) {
      console.error("Error @ getWeekData", error);
    }
  };

  useEffect(() => {
    getSalesList();
    fetchBrands();
    fetchMostActive();
  }, []);

  useEffect(() => {
    fetchBrands();
    fetchMostActive();
  }, [sales_id]);

  useEffect(() => {
    // getWeekNumber();
  }, []);

  const fetchMostActive = async () => {
    try {
      let res = await API({
        url: "/slotbooking/get-most-active-brands",
        method: "POST",
        responseType: "json",
        data: { sales_person_id: sales_id === -1 ? undefined : sales_id },
      });
      if (res.code === 200) {
        setMostActive(res.data);
      }
    } catch (error) {
      console.error("Error fetching brands:", error);
    }
  };
  const fetchBrands = async () => {
    try {
      let res = await API({
        url: "/slotbooking/get-brands",
        method: "POST",
        responseType: "json",
        data: { sales_person_id: sales_id === -1 ? undefined : sales_id },
      });
      if (res.code === 200) {
        // setInitialAssignedBrands([
        //   { label: "Select By Brand", value: -1 },
        //   ...res.data,
        // ]);
        setAssignedBrands([{ label: "Search Brand", value: -1 }, ...res.data]);
      }
    } catch (error) {
      console.error("Error fetching brands:", error);
    }
  };

  const filterOnClick = async () => {
    try {
      setShowFilter(!showFilter);
    } catch (error) {
      console.error("Error @ filterOnClick", error);
    }
  };

  const getSalesList = async () => {
    try {
      let salesListResponse = await API({
        url: "/user/sales_persons/getSalesUsers",
        method: "POST",
        responseType: "json",
      });
      if (salesListResponse.code === 200) {
        let tempArray = [{ label: "Select By Executive", value: 0 }];
        if (localStorage.getItem("role") === roles.salesperson)
          tempArray.push({ label: "Show Only Mine", value: -1 });
        tempArray = tempArray.concat(salesListResponse.data);
        setSalesList(tempArray);
      }
    } catch (error) {
      console.log("Error @ getSalesList", error);
    }
  };
  const LanguageFilterChange = (selected) => {
    setLangFilter(selected.value);
    setStateOptions([
      { label: "Select State", value: -1 },
      ...mainStateOptions
        .filter((item) => item.lang_id === selected.value)
        .map((item) => {
          return { label: item.state_name, value: item.state_id };
        }),
    ]);
    setDistrictsOptions([{ label: "Select District", value: -1 }]);
    setConstituencyOptions([{ label: "Select Constituency", value: -1 }]);

    setStateFilter(-1);
    setDistrictFilter(-1);
    setConstituencyFilter(-1);
  };
  const StateFilterChange = async (selected) => {
    let value = selected.value;
    setStateFilter(selected.value);
    setConstituencyOptions([{ label: "Select Constituency", value: -1 }]);
    if (parseInt(value) !== -1) {
      try {
        let res = await API({
          url: "/location/getDistrictsByStateId",
          method: "POST",
          responseType: "json",
          data: { states: [value], langs: [langFilter] },
        });
        let districts = [{ label: "Select District", value: -1 }];
        for await (let item of res.data) {
          const temp = { value: item.dist_id, label: `${item.dist_name}` };
          districts.push(temp);
        }
        setDistrictsOptions(districts);
      } catch (error) {
        console.error(error);
      }
    }
    setDistrictFilter(-1);
    setConstituencyFilter(-1);
  };

  const DistrictFilterChange = async (selected) => {
    try {
      let value = selected.value;
      setDistrictFilter(value);
      setConstituencyOptions([{ label: "Select Constituency", value: -1 }]);
      if (parseInt(value) !== -1) {
        try {
          let res = await API({
            url: "/location/getConstituentsnew",
            method: "POST",
            responseType: "json",
            data: { districts: [value], langs: [langFilter] },
          });
          let constituencies = [{ label: "Select Constituency", value: -1 }];
          for await (let item of res.data) {
            const temp = { value: item.const_id, label: `${item.const_name}` };
            constituencies.push(temp);
          }
          setConstituencyOptions(constituencies);
        } catch (error) {
          console.error(error);
        }
      }
      if (parseInt(value) === -1) {
        setConstituencyFilter(-1);
      }
    } catch (error) {
      console.error("Error @ DistrictFilterChange", error);
    }
  };

  const resetFilter = () => {
    setLangFilter(1);
    setStateFilter(-1);
    setDistrictFilter(-1);
    setConstituencyFilter(-1);
    setStateOptions([
      { label: "Select State", value: -1 },
      ...mainStateOptions
        .filter((item) => item.lang_id === 1)
        .map((item) => {
          return { label: item.state_name, value: item.state_id };
        }),
    ]);
    setDistrictsOptions([{ label: "Select District", value: -1 }]);
    setConstituencyOptions([{ label: "Select Constituency", value: -1 }]);
    setFilterBrand_id(-1);
    // setFilterDateRange({ startDate: null, endDate: null });
    setNewUserTypeFilter(0);
    setCreativeTypeFilter("");
    setCampaignTypeFilter("");
    setBillingTypeFilter("");
    setPaymentMethodFilter("");
    setPositionFilter(0);
    setSales_id(0)
  };

  const editAction = (item) => {
    try {
      setEditItem({ ...item, action: "edit" });
      setBookSlotModalOpen(true);
    } catch (error) {
      console.error("Error @ editAction", error);
    }
  };
  const getBrands = async (checker) => {
    try {
      if (!checker) return [];
      let requestObj = null;
      if (typeof checker === "number") {
        requestObj = { brand_id: +checker };
      } else if (checker) {
        requestObj = { search: checker };
      }
      if (!requestObj) {
        setAssignedBrands(initialAssignedBrands);
        return initialAssignedBrands;
      }
      const brandsResult = await API({
        url: "user/sales_persons/getBrands",
        method: "POST",
        responseType: "json",
        data: requestObj,
      });
      if (brandsResult?.code === 200) {
        let finalList = brandsResult.data.length
          ? [{ label: "Search Brand", value: -1 }, ...brandsResult.data]
          : initialAssignedBrands;
        setAssignedBrands(finalList);
        return finalList;
      } else return [];
    } catch (error) {
      console.error("Error @ getBrands", error);
    }
  };
  const debouncedGetBrands = debouncePromise(getBrands, 500); // Adjust the delay as needed

  // const deleteBookingSlot = async (slot_id) => {
  //   try {
  //     let res = await API({
  //       url: "/slotbooking/delete-booking",
  //       method: "POST",
  //       responseType: "json",
  //       data: {
  //         slot_id: slot_id,
  //       },
  //     });
  //     if (res.code === 200) {
  //       setBookingId(null);
  //       setDeleteSlotData({});
  //       getSlotsData();
  //       Toast("success", "Deleted Successfully");
  //     }
  //   } catch (error) {
  //     console.error("Error @ deleteBookingSlot", error);
  //   }
  // };

  const searchData = (e) => {
    setSearchText(e.target.value);
  };
  useEffect(() => {
    document
      ?.getElementById(`days${filterDateRange?.startDate?.getDate()}`)
      ?.scrollIntoView({ behavior: "smooth" });
    if (
      filterDateRange?.startDate &&
      filterDateRange?.startDate?.getMonth() !== currentDate.getMonth()
    ) {
      let tempDate = new Date(filterDateRange?.startDate?.getTime());
      tempDate.setDate(1);
      setCurrentDate(tempDate);
    }
  }, [filterDateRange]);

  const handleViewAction = async (slotItem) => {
    setSlotView_id(slotItem.slot_id);
  };
  const handleLogAction = async (slotItem) => {
    setSlotLog_id(slotItem.slot_id);
  };
  const handleEditAction = async (slotItem) => {
    try {
      let apiResult = await API({
        url: "/slotbooking/slot_details",
        method: "POST",
        responseType: "json",
        data: { slot_id: slotItem.slot_id },
      });
      if (apiResult.code === 200) {
        setEditItem({
          ...apiResult.data,
          action: "edit",
        });
        setBookSlotModalOpen(true);
        setInitialRender(false);
      }
    } catch (error) {
      console.error("Error @ handleEditAction", error);
    }
  };

  const handleDownload = async (url, brand) => {
    const pdfUrl = url;

    try {
      const response = await fetch(pdfUrl);
      const blob = await response.blob();
      const fileType = pdfUrl.split(".").pop();
      // Create a link element
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${brand}.${fileType}`;

      // Append the link to the body
      document.body.appendChild(link);

      // Trigger a click on the link to start the download
      link.click();

      // Remove the link from the body after the download is complete
      document.body.removeChild(link);
    } catch (error) {
      Toast("error", "Error downloading PDF");
      console.error("Error downloading PDF:", error);
    }
  };

  const handleDownloadOrders = async() => {
    try {
      setDownloadLoader(true)
      let apiResult = await API({
        url: "/slotbooking/download-booking-data",
        method: "POST",
        responseType: "json",
        data: {
          currentDate,
          dateRange:
            filterDateRange.startDate && !monthView
              ? filterDateRange
              : undefined,
          sales_id,
          brand_id: filterBrand_id !== -1 ? filterBrand_id : undefined,
          lang_id: langFilter !== -1 ? langFilter : undefined,
          state_id: stateFilter !== -1 ? stateFilter : undefined,
          district_id: districtFilter !== -1 ? districtFilter : undefined,
          const_id: constituencyFilter !== -1 ? constituencyFilter : undefined,
          searchText: searchText ? searchText : undefined,
          positionFilter: positionFilter ? positionFilter : undefined,
          statusFilter: statusFilter ? statusFilter : undefined,
          headApproveFilter: headApproveFilter ? headApproveFilter : undefined,
          newUserTypeFilter: newUserTypeFilter ? newUserTypeFilter : undefined,
          creativeTypeFilter: creativeTypeFilter
            ? creativeTypeFilter
            : undefined,
          campaignTypeFilter: campaignTypeFilter
            ? campaignTypeFilter
            : undefined,
          billingTypeFilter:
            billingTypeFilter !== "" ? billingTypeFilter : undefined,
          paymentMethodFilter:
            paymentMethodFilter !== "" ? paymentMethodFilter : undefined,
        },
      });
      if(apiResult.code === 200){
        setDownloadData(apiResult.data)
      }
      setDownloadLoader(false)
    } catch (error) {
      console.error("Error @ handleDownloadOrders", error)
    }
  }
  
  const downloadHeaders = [
    {label: "Sales Order Name", key: "slot_name"},
    {label: "Team", key: "new_user_type"},
    {label: "Sales Person", key: "sales_name"},
    {label: "Order Id", key: "order_id"},
    {label: "Company Name", key: "company_name"},
    {label: "Status", key: "status"},
    {label: "Sales Head", key: "sales_head_name"},
    {label: "CST Picked by", key: "cst_name"},
    {label: "Brand", key: "brand_name"},
    {label: "Company Mobile", key: "billing_mobile"},
    {label: "Company Email", key: "billing_email"},
    {label: "Brand Category", key: "category_name"},
    {label: "Brand Location", key: "brand_location"},
    {label: "Client Type", key: "client_type"},

    {label: "Payment Type", key: "payment_type"},
    {label: "Payment Method", key: "payment_method"},
    {label: "Package", key: "package_no"},
    {label: "Payment Id / RO.No", key: "payment_id"},
    {label: "Ro Value", key: "ro_value"},
    
    {label: "Ad Unit Id", key: "interal_id"},
    {label: "Date Ranges", key: "date_ranges"},
    {label: "Campaign Type", key: "campaign_type"},
    {label: "AdUnit Budget", key: "adunit_budget"},
    {label: "AdUnit Actual Price", key: "actual_price"},
    {label: "AdUnit Sales Price", key: "sales_price"},
    {label: "Creative Type", key: "creative_type"},
    {label: "Positions", key: "positions"},
    {label: "Slot", key: "slot"},
    {label: "Target", key: "target"},
    {label: "Billing Type", key: "billing"},
    {label: "Non Billing Order Id", key: "non_billing_order_id"},
    {label: "Non Billing Reason", key: "nonbillfile_url"},
    {label: "Description", key: "description"},
    {label: "RO File", key: "rofile_url"},
    {label: "PDC File", key: "pdcfile_url"},
    {label: "Sales Head Approved Reason", key: "approvereason_url"},
  ]
  useEffect(() => {
    if(downloadData.length){
      downloadRef?.current?.link?.click()
      setDownloadData([])
    }
  }, [downloadData])

  return (
    <div
      className={`${styles["booking-container"]}  ${
        localStorage.getItem("role") === roles.financer
          ? styles["fin-body"]
          : null
      }`}
    >
      <CSVLink
        data={downloadData?.map(
          (downItem) => {
            let noOfDays = getNumberOfDays(downItem.date_ranges);
            let obj = {
              slot_name: downItem.slot_name,
              new_user_type: BrandsTypes.find(item => item.value === downItem.new_user_type)?.label || '',
              sales_name: downItem.sales_name,
              order_id: downItem.order_id || "#N/A",
              company_name: downItem.company_name,
              status: downItem.status === 1
              ? "Pending"
              : downItem.status === 2
              ? "Finance Pending"
              : downItem.status === 3
              ? "Approved"
              : downItem.status === 4
              ? "Rejected"
              : "Deleted",
              sales_head_name: downItem?.approval_obj?.sales_head_name || "",
              cst_name: downItem?.approval_obj?.cst_name || "#N/A",
              brand_name: downItem?.brand_name,
              billing_mobile: downItem?.billing_mobile || "#N/A",
              billing_email: downItem?.billing_email || "#N/A",
              category_name: downItem?.category_name || "#N/A",
              brand_location: downItem?.brand_location || "#N/A",
              client_type: downItem?.client_type,
              payment_type: slotPaymentTypeOptions.find((item) => item.value === downItem.payment_type)?.label,
              payment_method: slotPaymentMethodOptions.find(
                (item) => item.value === downItem.payment_method
              )?.label,
              package_no: downItem.package_no === 1 ? "#N/A" : slotPackagesOptions.find(
                (item) => item.value === downItem.package_no
              )?.label,
              payment_id: downItem.payment_id || "#N/A",
              ro_value: downItem.ro_value || 0,
              billing: billingOptions.find(
                (item) => item.value === downItem.billing
              )?.label,
              non_billing_order_id: downItem?.non_billing_order_id || "#N/A",
              nonbillfile_url: downItem?.nonbillfile_url || "#N/A",
              description: downItem?.description || "#N/A",
              interal_id: downItem?.interal_id,
              date_ranges: downItem?.date_ranges.map(item => {
                return `${formatDateDDMMYYY(item.start_date)} - ${formatDateDDMMYYY(item.end_date)}`
              }).join(", "),
              campaign_type: downItem.campaign_type,
              adunit_budget: downItem.adunit_budget,
              actual_price: downItem.campaign_type === 'CPM' ? downItem.actual_price : noOfDays * downItem.actual_price,
              sales_price: downItem.campaign_type === 'CPM' ? downItem.sales_price : noOfDays * downItem.sales_price,
              creative_type: downItem.creative_type,
              positions: downItem.positions.map(item => `${item === -1 ? 'SOV' : `P${item}`}`).join(' ,'),
              slot: downItem.slot === 0
              ? "A"
              : downItem.slot === 1
              ? "B"
              : downItem.slot === 2
              ? "C"
              : "-",
              rofile_url: downItem.rofile_url || "#N/A",
              pdcfile_url: downItem.pdcfile_url || "#N/A",
              approvereason_url: downItem?.approval_obj?.approvereason_url || "#N/A"
            }
            let target = []
            if (downItem.actualTarget?.lang_ids?.length > 0)
              downItem?.actualTarget?.lang_ids.map((item, i) => {
                target.push(`${langoptions_preview[item]}(L)`)
              })
            if (Array.isArray(downItem?.actualTarget?.state_ids) &&
              downItem.actualTarget.state_ids?.length > 0)
              downItem.state_Objs
                .filter((st) =>
                  downItem.actualTarget.state_ids.includes(
                    st.state_id
                  )
                )
                .map((item) => {
                  target.push(`${item.state_name}(S)`)
                })
            if (Array.isArray(
              downItem?.actualTarget?.district_ids
            ) &&
              downItem.actualTarget.district_ids?.length > 0)
              downItem.district_Objs
                .filter((di) =>
                  downItem.actualTarget.district_ids.includes(
                    di.dist_id
                  )
                )
                .map((item, i) => (
                  target.push(`${item.dist_name}(D)`)
                ))
            if (Array.isArray(downItem?.constituency_Objs) &&
              downItem.constituency_Objs?.length > 0)
              downItem.constituency_Objs.map((item, i) => {
                return (
                  target.push(`${item.const_name}(C)`)
                );
              })
              console.log(target)
              obj.target = target.join(', ')
            return obj
          }
        )}
        headers={downloadHeaders}
        filename={"SalesOrdersReport.csv"}
        ref={downloadRef} // Assign the ref to the CSVLink component
      ></CSVLink>
      {/* Left Calendar Container View */}
      <div
        className={`${styles["calendar-panel"]}`}
        id={styles["calendarPanel"]}
      >
        <div
          className={`${styles["calendar-head"]} ${
            headerVisible ? "" : styles["hideheader"]
          }`}
          id={styles["calendarHead"]}
        >
          {/* Old Filters */}
          {/* <div className={styles["calendarView"]}>
            <div className={styles["calendar-navigator"]}>
              <div className={styles["month"]}>
                <button id={styles["previous-state"]} onClick={handlePrevClick}>
                  <img src={prevArrowSvg} alt="Go to Previous" />
                </button>
                <h1>
                  <img src={calendarSvg} alt="cal" />{" "}
                  <span>{`${currentMonth}, ${currentYear}`}</span>
                </h1>
                <button id={styles["next-state"]} onClick={handleNextClick}>
                  <img src={nextArrowSvg} alt="Go to Next" />
                </button>
              </div>
              {localStorage.getItem("role") === roles.salesperson ||
              localStorage.getItem("role") === roles.ops ? (
                <button
                  className={styles["book-ad-btn"]}
                  onClick={() => setBookSlotModalOpen(true)}
                >
                  <img src={addPlusIconSvg} alt="" />
                  <span>Book Order</span>
                </button>
              ) : null}
              <div className={styles["filter-options"]}>
                <Select
                  className={styles["option"]}
                  size="medium"
                  placeholder="Sales person"
                  value={defaultValue(salesList, sales_id)}
                  onChange={(selected) => {
                    setFilterBrand_id(-1);
                    setSales_id(selected.value);
                  }}
                  options={salesList}
                />
                {assignedBrands.length > 1 ? (
                  <Select
                    className={styles["option"]}
                    size="medium"
                    name="brand_id"
                    placeholder="Select a Brand"
                    value={defaultValue(assignedBrands, filterBrand_id)}
                    onChange={(selected) => {
                      setFilterBrand_id(selected.value);
                    }}
                    options={assignedBrands}
                    classNamePrefix="select"
                  />
                ) : null}
                <AsyncSelect
                  type="text"
                  name="brand_id"
                  placeholder="Select brand"
                  value={defaultValue(assignedBrands, filterBrand_id)}
                  onChange={(selected) => {
                    setFilterBrand_id(selected.value);
                  }}
                  loadOptions={debouncedGetBrands}
                  defaultOptions={assignedBrands}
                />
                <Select
                  className={styles["option"]}
                  size="medium"
                  placeholder="Select a status"
                  value={defaultValue(slotStatusOptions, statusFilter)}
                  onChange={(selected) => {
                    setStatusFilter(selected.value);
                  }}
                  options={slotStatusOptions}
                  classNamePrefix="select"
                />
                <Select
                  placeholder="Select Language"
                  name="lang"
                  size="medium"
                  onChange={LanguageFilterChange}
                  value={defaultValue(languageOptions, langFilter)}
                  options={languageOptions}
                  className={styles["option"]}
                />
                <div>
                  <SlInput
                    size="medium"
                    id="myInput"
                    onSlInput={debounce(searchData, 500)}
                    placeholder="Slot/Brand/Company"
                    className={styles["option"]}
                  >
                    <SlIcon
                      library="lucide"
                      name="search"
                      slot="prefix"
                    ></SlIcon>
                  </SlInput>
                </div>
                <button
                  className={`${styles["default-btn"]} ${styles["filters"]}`}
                  id={styles["applyFilters"]}
                  onClick={() => {
                    filterOnClick();
                  }}
                >
                  <span>Filter</span> <img src={filterIconSvg} alt="" />
                </button>
              </div>
            </div>
          </div> */}
          {/*<div className={styles["filtersView"]}>
            <div className={styles["slots-num"]}>
              <div className={styles["imgStack"]}>
                <img src="images/logo-1.svg" alt="" />
                <img src="images/logo-2.svg" alt="" />
                <img src="images/logo-3.svg" alt="" />
              </div>
              <p>
                {weekNumber} Slots <span>booked this week</span>
              </p>
              <button
                className={styles["view-btn"]}
                onClick={() => getWeekData()}
              >
                <img src={viewIconSvg} alt="" /> <span>View All</span>
              </button>
            </div>
            <button className="default-btn reminders">
              <img src={addPlusIconDarkSvg} alt="" /> <span>Add Reminder</span>
            </button>
          </div> */}
          <div
            className={`${styles["pageFilters"]} ${
              headerVisible ? styles["visible"] : ""
            }`}
          >
            <div className={styles["filtersCalendar"]}>
              <div className={styles["monthSelector"]}>
                <button
                  className={styles["prev-btn"]}
                  onClick={handlePrevClick}
                >
                  <i className={styles["arrow-icon"]}></i>
                </button>
                <p>
                  <i className={styles["month-icon"]}></i>{" "}
                  {`${currentMonth}, ${currentYear}`}
                </p>
                <button
                  className={styles["next-btn"]}
                  onClick={handleNextClick}
                >
                  <i className={styles["arrow-icon"]}></i>
                </button>
              </div>

              {!monthView ? (
                <div className={styles["daySelector"]}>
                  <button
                    className={styles["prev-btn"]}
                    onClick={() => {
                      setFilterDateRange({
                        startDate: subDays(filterDateRange.startDate, 1),
                        endDate: subDays(filterDateRange.startDate, 1),
                      });
                    }}
                  >
                    <i className={styles["arrow-icon"]}></i>
                  </button>
                  <ul id={styles["dayChanger"]}>
                    {eachDayOfInterval({
                      start: startOfMonth(currentDate),
                      end: endOfMonth(currentDate),
                    }).map((day) => (
                      <li
                        id={`days${day?.getDate()}`}
                        onClick={() => {
                          setFilterDateRange({ startDate: day, endDate: day });
                        }}
                        className={
                          filterDateRange.startDate?.getTime() === day.getTime()
                            ? styles["active"]
                            : ""
                        }
                      >
                        {/* {console.log(filterDateRange, day)} */}
                        <span>{weekDays[day.getDay()][0]}</span>
                        {day.getDate()}
                      </li>
                    ))}
                  </ul>
                  <button
                    className={styles["next-btn"]}
                    onClick={() => {
                      setFilterDateRange({
                        startDate: addDays(filterDateRange.startDate, 1),
                        endDate: addDays(filterDateRange.startDate, 1),
                      });
                    }}
                  >
                    <i className={styles["arrow-icon"]}></i>
                  </button>
                </div>
              ) : null}

              <button
                className={styles["swith-view-btn"]}
                onClick={() => {
                  setMonthView(!monthView);
                  let tempCurrentDate = new Date(currentDate.getTime());
                  tempCurrentDate.setDate(1);
                  setFilterDateRange({
                    startDate: tempCurrentDate,
                    endDate: tempCurrentDate,
                  });
                }}
              >
                <i className={styles["swith-icon"]}></i>{" "}
                <span>Switch to {monthView ? "Date" : "Month"} view</span>
              </button>
              <button
                className={styles["mobflt-close"]}
                onClick={() => setHeaderVisible(!headerVisible)}
              >
                <img src={closeSvg} alt="close2" />
              </button>
              {localStorage.getItem("role") === roles.ops ? (
                  <div className={`${styles["download-btn"]} mobileOnly`}>{downloadLoader ? <TableLoader /> : 
                  <button
                    onClick={() => handleDownloadOrders()}
                  >
                    <img src={downloadIcon} alt="" />
                  </button>}</div>
                ) : null}
            </div>

            <div className={styles["otherFiltes"]}>
              <div className={styles["langTeamFilters"]}>
                <div className={styles["langsGrp"]}>
                  <label id={styles["chikLabel"]}>Language</label>
                  {languageOptions.map((langItem) => {
                    return (
                      <div className={styles["radioGrp"]}>
                        <input
                          type="radio"
                          id={langItem.label}
                          name="lang"
                          value={langItem.value}
                          onClick={() => {
                            setLangFilter(langItem.value);
                            LanguageFilterChange(langItem);
                          }}
                          checked={langFilter === langItem.value}
                        />
                        <label for={langItem.label}>{langItem.label}</label>
                      </div>
                    );
                  })}
                </div>

                <div className={styles["teamsGrp"]}>
                  <label id={styles["chikLabel"]}>Team</label>
                  <div className={styles["radioGrp"]}>
                    <input
                      type="radio"
                      id={"All"}
                      name="team"
                      value={0}
                      onClick={() => {
                        setNewUserTypeFilter(0);
                      }}
                      checked={newUserTypeFilter === 0}
                    />
                    <label for={"All"}>{"All"}</label>
                  </div>
                  {BrandsTypes.map((brandItem) => {
                    return (
                      <div className={styles["radioGrp"]}>
                        <input
                          type="radio"
                          id={brandItem.label}
                          name="team"
                          value={brandItem.value}
                          onClick={() => {
                            setNewUserTypeFilter(brandItem.value);
                          }}
                          checked={newUserTypeFilter === brandItem.value}
                        />
                        <label for={brandItem.label}>{brandItem.label}</label>
                      </div>
                    );
                  })}
                  {/* <div className={styles["subGrp"]}></div>{" "} */}
                  {/* Sub Local new user types*/}
                </div>
              </div>
              <div className={styles["chooseLocations"]}>
                <Select
                  placeholder="Select State"
                  name="state"
                  id={styles["state"]}
                  size="small"
                  onChange={(selected) => {
                    StateFilterChange(selected);
                  }}
                  value={defaultValue(stateOptions, stateFilter)}
                  className={styles["select"]}
                  options={stateOptions}
                ></Select>
                <Select
                  placeholder="Select District"
                  name="district"
                  id={styles["district"]}
                  size="small"
                  onChange={(selected) => {
                    DistrictFilterChange(selected);
                  }}
                  value={defaultValue(districtOptions, districtFilter)}
                  className={styles["select"]}
                  options={districtOptions}
                ></Select>
                <Select
                  placeholder="Select Constituency"
                  name="constituency"
                  id={styles["constituency"]}
                  size="small"
                  onChange={(selected) => {
                    setConstituencyFilter(selected.value);
                  }}
                  value={defaultValue(constituencyOptions, constituencyFilter)}
                  options={constituencyOptions}
                  className={styles["select"]}
                ></Select>
                <div className={`${styles["searchBar"]} desktopOnly`}>
                  <input
                    type="text"
                    name="search"
                    id={styles["search"]}
                    placeholder="enter order/brand/campaign"
                    onChange={debounce(searchData, 500)}
                  />
                </div>
                {localStorage.getItem("role") === roles.salesperson ||
                localStorage.getItem("role") === roles.ops ? (
                  <button
                    className={styles["book-ad-btn"]}
                    onClick={() => setBookSlotModalOpen(true)}
                  >
                    <img src={addPlusIconSvg} alt="" />
                    <span>Book Order</span>
                  </button>
                ) : null}
                {localStorage.getItem("role") === roles.ops ? (
                  <div className={`${styles["download-btn"]} desktopOnly`}>{downloadLoader ? <TableLoader /> : <button                 
                    onClick={() => handleDownloadOrders()}
                  >
                    <img src={downloadIcon} alt="" />
                    <span>Download</span>
                  </button>}</div>
                ) : null}
              </div>
              <div className={styles["chooseBy"]}>
                {/* <div className={styles["selctGrp"]}>
                  <label for="">Order Name</label>
                  <select name="order" id="">
                    <option value="Order Name" selected>
                      Order Name
                    </option>
                    <option value="">---</option>
                  </select>
                </div> */}
                <div className={styles["selctGrp"]}>
                  <label for="">Brand Name</label>
                  <AsyncSelect
                    type="text"
                    name="brand_id"
                    placeholder="Search brand"
                    value={defaultValue(assignedBrands, filterBrand_id)}
                    onChange={(selected) => {
                      setFilterBrand_id(selected.value);
                    }}
                    loadOptions={debouncedGetBrands}
                    className={styles["select"]}
                    noOptionsMessage={() => "Type searching Brand"}
                    defaultOptions={[{ label: "Search Brand", value: -1 }]}
                  />
                </div>
                <div
                  className={styles["selctGrp"]}
                  onChange={(e) => {
                    setCreativeTypeFilter(e.target.value);
                  }}
                >
                  <label for="">Creative Type</label>
                  <select name="" id="" className={styles["select"]} value={creativeTypeFilter}>
                    <option value="" selected>
                      Select
                    </option>
                    {slotBookingCreativeTypes.map((item) => (
                      <option value={item.value}>{item.label}</option>
                    ))}
                  </select>
                </div>
                {/* <div className={styles["selctGrp"]}>
                  <label for="">Ad Location</label>
                  <select name="" id="">
                    <option value="Ad Location" selected>
                      Ad Location
                    </option>
                    <option value="">---</option>
                  </select>
                </div> */}
                <div
                  className={styles["selctGrp"]}
                  onChange={(e) => {
                    setCampaignTypeFilter(e.target.value);
                  }}
                >
                  <label for="">Type Of Campaign</label>
                  <select name="" id="" className={styles["select"]} value={campaignTypeFilter}>
                    <option value="">Select</option>
                    <option value="CPD">CPD</option>
                    <option value="CPM">CPM</option>
                  </select>
                </div>
                <div className={styles["selctGrp"]}>
                  <label for="">Ad Position</label>
                  <select
                    className={styles["select"]}
                    name=""
                    id=""
                    onChange={(e) => {
                      setPositionFilter(+e.target.value);
                    }}
                    value={+positionFilter}
                  >
                    {[0, ...slotPositions.filter(item => item)].map((position) => (
                      <option value={position}>
                        {position === -1
                          ? "SOV"
                          : position === 0
                          ? "Ad Position"
                          : `P${position}`}
                      </option>
                    ))}
                  </select>
                </div>
                {/* <div className={styles["selctGrp"]}>
                  <label for="">Ad Pub. Date</label>
                  <input
                    type="date"
                    name="date"
                    id={styles["pubDate"]}
                    value=""
                    placeholder=""
                  />
                </div> */}
                <div className={styles["selctGrp"]}>
                  <label for="">Sales Executive</label>
                  <Select
                    className={styles["option"]}
                    size="medium"
                    placeholder="Sales person"
                    value={defaultValue(salesList, sales_id)}
                    onChange={(selected) => {
                      setFilterBrand_id(-1);
                      setSales_id(selected.value);
                    }}
                    options={salesList}
                  />
                </div>
                <div className={styles["selctGrp"]}>
                  <label for="">Billing Type</label>
                  <select
                    name=""
                    id=""
                    className={styles["select"]}
                    onChange={(e) => {
                      setBillingTypeFilter(e.target.value);
                    }}
                    value={billingTypeFilter}
                  >
                    <option value="">Select</option>
                    {billingOptions.map((billingItem) => {
                      return (
                        <option value={billingItem.value}>
                          {billingItem.label}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className={styles["selctGrp"]}>
                  <label for="">Payment Method</label>
                  <select
                    name=""
                    id=""
                    className={styles["select"]}
                    onChange={(e) => {
                      setPaymentMethodFilter(e.target.value);
                    }}
                    value={paymentMethodFilter}
                  >
                    <option value="">Select</option>
                    {slotPaymentMethodOptions.map((paymentItem) => {
                      return (
                        <option value={paymentItem.value}>
                          {paymentItem.label}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </div>

            <div className={styles["resetBtn"]}>
              <div className={`${styles["searchBar"]} ${styles["mobileOnly"]}`}>
                <input
                  type="text"
                  name="search"
                  id={styles["search"]}
                  placeholder="enter order/brand/campaign"
                  onChange={debounce(searchData, 500)}
                />
              </div>
              <button className={styles[""]} onClick={() => resetFilter()}>
                <i className={styles["reset"]}></i> Reset Filters
              </button>
            </div>
          </div>
        </div>
        <div className={`${styles["toggleHead"]}`}>
          <button
            className={styles["toggleButton"]}
            onClick={() => setHeaderVisible(!headerVisible)}
          >
            {headerVisible ? (
              <img src={ToogleLeftSvg} alt="" className="desktopOnly" />
            ) : (
              <img src={ToogleRightSvg} alt="" className="desktopOnly" />
            )}
            <img src={hamburger} alt="" className="mobileOnly" />
          </button>
        </div>
        <div className={`${styles["calendar-body"]}`}>
          <div className={styles["sticky-options"]}>
            {/* <h5>
              <img src={verticalViewSvg} alt="" />{" "}
              <span>View Results By : </span>
            </h5>
            <ul class={styles["posList"]}>
              {[0, ...slotPositions].map((position) => (
                <li
                  className={
                    position === positionFilter ? styles["active"] : ""
                  }
                  onClick={() => {
                    setPositionFilter(position);
                  }}
                >
                  <span>
                    {position === -1
                      ? "SOV"
                      : position === 0
                      ? "All"
                      : `P${position}`}
                  </span>
                </li>
              ))}
            </ul> */}
            {salesUsersList.length > 1 ||
            localStorage.getItem("role") === roles.financer ||
            localStorage.getItem("role") === roles.ops ? (
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  checked={headApproveFilter}
                  onChange={(e) => {
                    setHeadApproveFilter(!headApproveFilter);
                  }}
                />
                {localStorage.getItem("role") === roles.ops
                  ? "UnPicked Orders"
                  : "Pending Approvals"}
              </div>
            ) : null}
            <button
              className={styles["activity-btn"]}
              onClick={() => setShowActivity(true)}
            >
              <img src={activityViewIconSvg} alt="" />{" "}
              <span>My Recent Activity</span>
            </button>
            <ul className={`${styles["indications"]} mobHide`}>
              <li>Approved</li>
              <li>Rejected</li>
              <li>Pending</li>
              <li>Finance Pending</li>
            </ul>
          </div>
          <div
            className={`${styles["calendar-view-style"]} ${
              monthView ? "" : styles["date-view"]
            }`}
            id={styles["monthly-view"]}
          >
            {data?.length && !loader ? (
              <>
                {/* {Array.from({
                  length: weekDays.indexOf(
                    format(new Date(data[0].date), "EEE")
                  ),
                }).map((_, index) => {
                  return (
                    <div className={styles["dayPosCard"]}>
                      <div className={styles["day"]}>
                        <h6>{weekDays[index]}</h6>
                      </div>
                    </div>
                  );
                })} */}

                {data.map((dateItem) => {
                  return (
                    <div
                      className={styles["dayPosCard"]}
                      id={new Date(dateItem.date).getTime()}
                    >
                      {/* {window.innerWidth <= 767 ? (
                      <label className={styles["date-label"]}>
                        {format(new Date(dateItem.date), "do MMMM")}
                      </label>
                    ) : null} */}
                      <div className={styles["day"]}>
                        <h6>{format(new Date(dateItem.date), "EEE")}</h6>
                        <h1>{format(new Date(dateItem.date), "d")}</h1>
                      </div>
                      {(localStorage.getItem("role") === roles.salesperson ||
                        localStorage.getItem("role") === roles.ops) &&
                      Math.floor(new Date(dateItem.date).getTime() / 1000) >=
                        Math.floor(new Date().setHours(0, 0, 0, 0) / 1000) ? (
                        <button
                          className={styles["book-ad-btn"]}
                          onClick={() => {
                            setEditItem({
                              date_ranges: [
                                {
                                  start_date: Math.floor(
                                    new Date(dateItem.date).getTime() / 1000
                                  ),
                                  end_date: Math.floor(
                                    new Date(dateItem.date).getTime() / 1000
                                  ),
                                },
                              ],
                            });
                            setBookSlotModalOpen(true);
                          }}
                        >
                          <img src={AddPlusWhiteSvg} alt="" /> <span>Book</span>
                        </button>
                      ) : null}
                      <div
                        className={styles["card-wrapper"]}
                        onClick={() => {
                          if (monthView) {
                            let tempDate = formatDateYYYYMMDD(
                              new Date(dateItem.date).getTime() / 1000
                            );
                            setModelViewDateRange({
                              startDate: tempDate,
                              endDate: tempDate,
                            });
                          }
                        }}
                      >
                        {!monthView ? (
                          <div
                            className={`${styles["slot-card"]}  ${styles["headers"]}`}
                          >
                            <div></div>
                            <div></div>
                            <div className={`${styles["slot-details"]} `}>
                              <h2 className={styles["slot-placement"]}>
                                <span></span>
                              </h2>
                              <div className={styles["slot-row"]}>
                                <span
                                  className={`${styles["name-field"]} ${styles["order-name"]}`}
                                >
                                  Slot Name
                                </span>
                                <span className={styles["name-field"]}>
                                  Brand Name
                                </span>
                                <span
                                  className={`${styles["name-field"]} ${styles["creative-type"]}`}
                                >
                                  Creative Type
                                </span>
                                <span
                                  className={`${styles["name-field"]} ${styles["creative-type"]}`}
                                >
                                  Campaign Type
                                </span>
                              </div>

                              <div className={styles["slot-row"]}>
                                <ul className={styles["locations-list"]}>
                                  Targets
                                </ul>
                                <span>Start Date</span>
                                <span>Budget</span>
                              </div>
                            </div>
                          </div>
                        ) : null}
                        {dateItem.positionsData.map((positionItem) => {
                          return (
                            <div
                              className={`${styles["slot-card"]} ${
                                positionItem?.slots?.length > 1
                                  ? `${styles["multi-pos"]}`
                                  : ""
                              } ${
                                positionItem?.slots?.filter(
                                  (mitem) => mitem?.mine
                                ).length
                                  ? styles["my-slot"]
                                  : ""
                              }`}
                            >
                              <div className={styles["slot-position"]}>
                                <span>{`${
                                  positionItem.position === -1
                                    ? "SOV"
                                    : `P${positionItem.position}`
                                }`}</span>
                              </div>
                              {positionItem.slots.map((slotItem) => {
                                let {
                                  slot,
                                  actualTarget,
                                  state_Objs,
                                  district_Objs,
                                  mandal_Objs,
                                  constituency_Objs,
                                  village_Objs,
                                  slot_name,
                                } = slotItem;
                                return (
                                  <div
                                    className={`${styles["slot-details"]} ${
                                      slotItem.status === 1
                                        ? styles["pending"]
                                        : slotItem.status === 2
                                        ? styles["finance_pending"]
                                        : slotItem.status === 3
                                        ? styles["approved"]
                                        : slotItem.status === 4
                                        ? styles["rejected"]
                                        : styles["deleted"]
                                    } ${
                                      slotItem.mine ||
                                      localStorage.getItem("role") ===
                                        roles.financer
                                        ? styles["my-slot"]
                                        : ""
                                    }
                                  
                                  cursor-pointer`}
                                    title={slot_name}
                                  >
                                    <div className={styles["slot-row"]}>
                                      {slotItem?.logo_url ||
                                      getGenerateUrl(slotItem?.brand_name || "") ? (
                                        <img
                                          src={
                                            slotItem?.logo_url ||
                                            getGenerateUrl(slotItem?.brand_name || "")
                                          }
                                          className={styles["brand-logo"]}
                                          title={slotItem.brand_name}
                                        />
                                      ) : null}

                                      <h2 className={styles["slot-placement"]}>
                                        <span>
                                          {slot === 0
                                            ? "A"
                                            : slot === 1
                                            ? "B"
                                            : slot === 2
                                            ? "C"
                                            : "-"}
                                        </span>
                                      </h2>
                                      {!monthView ? (
                                        <>
                                          <span
                                            className={`${styles["name-field"]} ${styles["order-name"]}`}
                                          >
                                            <p
                                              className={`${styles["field-name"]} mobileOnly`}
                                            >
                                              Slot Name
                                            </p>
                                            {slotItem.slot_name}
                                          </span>
                                          <span
                                            className={styles["name-field"]}
                                            title={slotItem.brand_name}
                                          >
                                            <p
                                              className={`${styles["field-name"]} mobileOnly`}
                                            >
                                              Brand Name
                                            </p>
                                            {slotItem.brand_name}
                                          </span>
                                          <span
                                            className={`${styles["name-field"]} ${styles["creative-type"]}`}
                                            title={
                                              slotBookingCreativeTypes.find(
                                                (item) =>
                                                  item.value ===
                                                  slotItem.creative_type
                                              )?.label
                                            }
                                          >
                                            <p
                                              className={`${styles["field-name"]} mobileOnly`}
                                            >
                                              Creative Type
                                            </p>
                                            {
                                              slotBookingCreativeTypes.find(
                                                (item) =>
                                                  item.value ===
                                                  slotItem.creative_type
                                              )?.label
                                            }
                                          </span>
                                          <span
                                            className={`${styles["name-field"]} ${styles["creative-type"]}`}
                                          >
                                            <p
                                              className={`${styles["field-name"]} mobileOnly`}
                                            >
                                              Campaign Type
                                            </p>
                                            {slotItem.campaign_type}
                                          </span>
                                        </>
                                      ) : null}
                                    </div>

                                    <div
                                      className={`${styles["slot-row"]} ${styles["mob-second-row"]}`}
                                    >
                                      <ul className={styles["locations-list"]}>
                                        {actualTarget?.lang_ids && actualTarget?.lang_ids?.length > 0 ? actualTarget?.lang_ids.map(
                                          (lang_id) => (
                                            <li
                                              className={styles["lang"]}
                                            >{`${langoptions_preview[lang_id]}`}</li>
                                          )
                                        ) : null}

                                        {actualTarget?.state_ids?.length ? state_Objs
                                          .filter((st) =>
                                            actualTarget.state_ids.includes(
                                              st.state_id
                                            )
                                          )
                                          .map((item) => (
                                            <li
                                              className={styles["state"]}
                                            >{`${item.state_name}`}</li>
                                          )) : null}

                                        {actualTarget?.district_ids?.length ? district_Objs
                                          .filter((di) =>
                                            actualTarget.district_ids.includes(
                                              di.dist_id
                                            )
                                          )
                                          .map((item) => (
                                            <li
                                              className={styles["dist"]}
                                            >{`${item.dist_name}`}</li>
                                          )) : null}

                                        {constituency_Objs?.length ? constituency_Objs?.map((item) => (
                                          <li
                                            className={styles["consti"]}
                                          >{`${item.const_name}`}</li>
                                        )) : null}
                                      </ul>
                                      {!monthView ? (
                                        <>
                                          <span>
                                            <p
                                              className={`${styles["field-name"]} mobileOnly`}
                                            >
                                              Start Date
                                            </p>
                                            {formatDateDDMMYYY(
                                              slotItem.start_date
                                            )}
                                          </span>
                                          <span>
                                            <p
                                              className={`${styles["field-name"]} mobileOnly`}
                                            >
                                              Budget
                                            </p>
                                            {`₹${slotItem.adunit_budget}`}
                                          </span>
                                        </>
                                      ) : null}
                                    </div>

                                    {!monthView ? (
                                      <div
                                        className={styles["date-view-options"]}
                                      >
                                        {slotItem.rofile_url ? (
                                          <button
                                            id="roFile"
                                            onClick={() => {
                                              handleDownload(
                                                slotItem?.rofile_url,
                                                `${slotItem?.slot_name}_RO`
                                              );
                                            }}
                                            title={"Download RO"}
                                          >
                                            <img src={downIcon} alt="" />
                                            <span>Ro</span>
                                          </button>
                                        ) : null}
                                        {localStorage.getItem("role") ===
                                          roles.salesperson &&
                                        slotItem.mine &&
                                        slotItem.status === 4 ? (
                                          <button
                                            id="edit"
                                            className={styles["editSlot"]}
                                            onClick={() => {
                                              handleEditAction(slotItem);
                                            }}
                                            title={"Edit Order"}
                                          >
                                            <img src={EditIconsSvg} alt="" />
                                            <span>Edit</span>
                                          </button>
                                        ) : null}
                                        <button
                                          id="view"
                                          onClick={() => {
                                            handleViewAction(slotItem);
                                          }}
                                          title={"View"}
                                        >
                                          <img src={viewIconSvg} alt="" />
                                          <span>View</span>
                                        </button>
                                        <button
                                          id="logs"
                                          onClick={() => {
                                            handleLogAction(slotItem);
                                          }}
                                          title={"Updates History"}
                                        >
                                          <img src={logsIconSvg} alt="" />
                                          <span>Logs</span>
                                        </button>
                                        {/* <button
                                id="delete"
                                onClick={() => {
                                  setDeleteSlotData(slotItem);
                                }}
                              >
                                <img src={DeleteIconSvg} alt="" />
                                <span>Delete</span>
                              </button> */}
                                      </div>
                                    ) : null}

                                    {slotItem.order_id ? (
                                      <div className={styles["picked"]}> </div>
                                    ) : null}
                                  </div>
                                );
                              })}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </>
            ) : !data?.length && !loader ? (
              <div className="w-full h-full d-flex justify-center">
                <NoDataFound colspan="15" />
              </div>
            ) : (
              <div className="w-full h-full d-flex justify-center">
                <TableLoader colspan="15" />
              </div>
            )}
          </div>
        </div>
        {/* RightPanel Toggle Button */}
        {/* <button
          id={styles["toggleButton"]}
          className={showActivity ? styles["opened"] : ""}
          onClick={() => setShowActivity(!showActivity)}
        >
          <img src={ToogleLeftSvg} alt="" />
        </button> */}
        {/* Filters Modal Content */}
        {/* {showFilter ? (
          <div className={styles["filtersModal"]}>
            <div className={styles["pos-popup-container"]}>
              <div className={styles["pos-popup-header"]}>
                <h3>Filters</h3>
                <span
                  className={styles["close"]}
                  onClick={() => {
                    setShowFilter(false);
                  }}
                >
                  <img src={closeSvg} alt="Close" />
                </span>
              </div>
              <div className={styles["pos-popup-body"]}>
                <div className={styles["form-container"]}>
                  <div className={styles["row-stack-2"]}>
                    <div className={styles["field-set"]}>
                      <label>By Date</label>
                      <div className="min-w-[280px] border">
                        <Datepicker
                          showShortcuts={true}
                          onChange={(value) => setFilterDateRange(value)}
                          value={filterDateRange}
                          primaryColor={"blue"}
                          configs={{
                            shortcuts: {
                              today: "today",
                              tomorrow: {
                                text: "Tomorrow",
                                period: {
                                  start: new Date(
                                    new Date().setDate(new Date().getDate() + 1)
                                  ),
                                  end: new Date(
                                    new Date().setDate(new Date().getDate() + 1)
                                  ),
                                },
                              },
                              next8Days: {
                                text: "Next 8 days",
                                period: {
                                  start: new Date(
                                    new Date().setDate(new Date().getDate() + 1)
                                  ),
                                  end: new Date(
                                    new Date().setDate(new Date().getDate() + 8)
                                  ),
                                },
                              },
                              nextMonth: {
                                text: "Next Month",
                                period: {
                                  start: new Date(
                                    new Date().getFullYear(),
                                    new Date().getMonth() + 1,
                                    1
                                  ),
                                  end: new Date(
                                    new Date().getFullYear(),
                                    new Date().getMonth() + 2,
                                    0
                                  ),
                                },
                              },
                            },
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className={styles["field-set-tree"]}>
                    {mostActive.length ? (
                      <>
                        {" "}
                        <h6>By Popularity</h6>
                        <div className={styles["field-row"]}>
                          {mostActive.map((item, index) => (
                            <div className={styles["r-contain"]}>
                              <input
                                type="radio"
                                name="brand_id"
                                id={`brands-${item.brand_id}`}
                                value={item.brand_id}
                                onChange={(e) => {
                                  setFilterBrand_id(+e.target.defaultValue);
                                }}
                                checked={filterBrand_id === item.brand_id}
                              />
                              <label htmlFor={`brands-${item.brand_id}`}>
                                {item.brand_name}
                              </label>
                            </div>
                          ))}
                        </div>
                      </>
                    ) : null}

                    <h6>By Location</h6>
                    <div className={`${styles["row-stack-2"]} mt-3`}>
                      {langFilter !== -1 && (
                        <div className={styles["field-set"]}>
                          <label>State</label>
                          <Select
                            placeholder="Select State"
                            name="state"
                            size="small"
                            onChange={(selected) => {
                              StateFilterChange(selected);
                            }}
                            value={defaultValue(stateOptions, stateFilter)}
                            options={stateOptions}
                            className="basic-multi-select w-full"
                          ></Select>
                        </div>
                      )}
                    </div>
                    <div className={`${styles["row-stack-2"]} mt-3`}>
                      <div className={styles["field-set"]}>
                        <label>District</label>
                        <Select
                          placeholder="Select District"
                          name="district"
                          size="small"
                          onChange={(selected) => {
                            DistrictFilterChange(selected);
                          }}
                          value={defaultValue(districtOptions, districtFilter)}
                          options={districtOptions}
                          className="basic-multi-select w-full"
                        ></Select>
                      </div>
                      <div className={styles["field-set"]}>
                        <label>Constituency</label>
                        <Select
                          placeholder="Select Constituency"
                          name="onstituency"
                          size="small"
                          onChange={(selected) => {
                            setConstituencyFilter(selected.value);
                          }}
                          value={defaultValue(
                            constituencyOptions,
                            constituencyFilter
                          )}
                          options={constituencyOptions}
                          className="basic-multi-select w-full"
                        ></Select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles["pos-popup-footer"]}>
                <button
                  className={`${styles["close"]} ${styles["btn-cancel"]}`}
                  onClick={() => resetFilter()}
                >
                  <span>Reset All</span>
                </button>
                <button
                  className={styles["btn-submit"]}
                  onClick={() => {
                    setShowFilter(false);
                    getSlotsData();
                  }}
                >
                  <span>Apply Filters</span>{" "}
                  <img src={angleRightSvg} alt="submit" />
                </button>
              </div>
            </div>
          </div>
        ) : null} */}
        {/* Book Slot Modal Content */}
        {bookSlotModalOpen && (
          <BookSlot
            show={bookSlotModalOpen}
            setShow={setBookSlotModalOpen}
            editItem={editItem}
          />
        )}
        {/* Book Slot Modal Content */}
      </div>
      {/* Right Side Recent Activity */}
      {showActivity ? (
        <UserActivity
          hideActivity={!showActivity}
          showActivity={showActivity}
          setShowActivity={setShowActivity}
        />
      ) : null}

      {/* <Modal show={Object.keys(deleteSlotData)?.length ? true : false}>
        <Modal.Header>
          <Modal.Title>Are you sure!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-col gap-2 ">
            <p className="d-flex justify-start gap-12 ml-8 ">
              {" "}
              <span className="min-w-[5rem]">Brand :</span>
              <span style={{ fontFamily: "Arial", fontWeight: "bold" }}>
                {deleteSlotData.brand_name}
              </span>{" "}
            </p>
            <p className="d-flex justify-start gap-12 ml-8 ">
              {" "}
              <span className="min-w-[5rem]">Position :</span>
              <span style={{ fontFamily: "Arial", fontWeight: "bold" }}>
                {deleteSlotData.position}
              </span>{" "}
            </p>
            <p className="d-flex justify-start gap-12 ml-8 ">
              {" "}
              <span className="min-w-[5rem]">Slot :</span>
              <span style={{ fontFamily: "Arial", fontWeight: "bold" }}>
                {deleteSlotData.slot === 0
                  ? "A"
                  : deleteSlotData.slot === 1
                  ? "B"
                  : deleteSlotData.slot === 2
                  ? "C"
                  : "-"}
              </span>{" "}
            </p>
            <p className="d-flex justify-start gap-12 ml-8 ">
              {" "}
              <span className="min-w-[5rem]">Start Date :</span>
              <span style={{ fontFamily: "Arial", fontWeight: "bold" }}>
                {formatDateWithTime(deleteSlotData.start_date)}
              </span>{" "}
            </p>
            <p className="d-flex justify-start gap-12 ml-8 ">
              {" "}
              <span className="min-w-[5rem]">End Date :</span>
              <span style={{ fontFamily: "Arial", fontWeight: "bold" }}>
                {formatDateWithTime(deleteSlotData.end_date)}
              </span>{" "}
            </p>
          </div>

          <div className="d-flex justify-between mt-2">
            <Button
              variant="success"
              onClick={() => {
                setDeleteSlotData({});
              }}
            >
              Cancel
            </Button>
            <Button
              className="ml-2"
              variant="danger"
              onClick={() => {
                deleteBookingSlot(deleteSlotData.slot_id);
              }}
            >
              Confirm
            </Button>
          </div>
        </Modal.Body>
      </Modal> */}
      {modelViewDateRange ? (
        <SlotModelView
          dateFilter={modelViewDateRange}
          setDateFilter={setModelViewDateRange}
          filterData={{
            currentDate,
            dateRange: modelViewDateRange.startDate
              ? modelViewDateRange
              : undefined,
            sales_id,
            brand_id: filterBrand_id !== -1 ? filterBrand_id : undefined,
            lang_id: langFilter !== -1 ? langFilter : undefined,
            state_id: stateFilter !== -1 ? stateFilter : undefined,
            district_id: districtFilter !== -1 ? districtFilter : undefined,
            const_id:
              constituencyFilter !== -1 ? constituencyFilter : undefined,
            searchText: searchText ? searchText : undefined,
            positionFilter: positionFilter ? positionFilter : undefined,
            statusFilter: statusFilter ? statusFilter : undefined,
            headApproveFilter: headApproveFilter
              ? headApproveFilter
              : undefined,
          }}
        />
      ) : null}

      {slotView_id ? (
        <SlotVIew slot_id={slotView_id} setSlot_id={setSlotView_id} />
      ) : null}
      {slotLog_id ? (
        <SlotHistory slotLog_id={slotLog_id} setSlotLog_id={setSlotLog_id} />
      ) : null}
    </div>
  );
}

export default SalesSlotBooking;

// <div className="slot-details">
//                               <div className="slot-row">
//                                 <img
//                                   src="images/logo-5.svg"
//                                   alt=""
//                                   className="brand-logo"
//                                 />
//                                 <h3>Colgate Palmolive</h3>
//                                 <h2 className="slot-placement">
//                                   <span>B</span>
//                                 </h2>
//                                 <img
//                                   src="images/exec-1.png"
//                                   alt=""
//                                   className="executive-logo"
//                                 />
//                               </div>
//                               <div className="slot-row">
//                                 <ul className="locations-list">
//                                   <li>TG &amp; Hyd</li>
//                                   <li>National</li>
//                                   <li>AP &amp; TG</li>
//                                 </ul>
//                               </div>
//                             </div>

// <div className="slot-card">
//                         <div className="slot-position">
//                           <span>P3</span>
//                         </div>
//                         <div className="slot-details">
//                           <div className="slot-row">
//                             <img
//                               src="images/logo-6.svg"
//                               alt=""
//                               className="brand-logo"
//                             />
//                             <h3>Life Insurance Corporation Of India</h3>
//                             <h2 className="slot-placement">
//                               <span>A</span>
//                             </h2>
//                             <img
//                               src="images/exec-1.png"
//                               alt=""
//                               className="executive-logo"
//                             />
//                           </div>
//                           <div className="slot-row">
//                             <ul className="locations-list">
//                               <li>South</li>
//                               <li>Hindi: National</li>
//                               <li>Telugu: AP &amp; TG</li>
//                             </ul>
//                           </div>
//                         </div>
//                       </div>
//                       <div className="slot-card">
//                         <div className="slot-position">
//                           <span>P5</span>
//                         </div>
//                         <div className="slot-details">
//                           <div className="slot-row">
//                             <img
//                               src="images/logo-7.svg"
//                               alt=""
//                               className="brand-logo"
//                             />
//                             <h3>Bajaj Finserv</h3>
//                             <h2 className="slot-placement">
//                               <span>A</span>
//                             </h2>
//                             <img
//                               src="images/exec-1.png"
//                               alt=""
//                               className="executive-logo"
//                             />
//                           </div>
//                           <div className="slot-row">
//                             <ul className="locations-list">
//                               <li>South</li>
//                               <li>Hindi: National</li>
//                               <li>Telugu: AP &amp; TG</li>
//                             </ul>
//                           </div>
//                         </div>
//                         {/* Card Hover Options */}
//                         <div className="options">
//                           <button id="edit" className="editSlot">
//                             <img src={EditIconsSvg} alt="" />
//                             <span>Edit</span>
//                           </button>
//                           <button id="delete">
//                             <img src={DeleteIconSvg} alt="" />
//                             <span>Delete</span>
//                           </button>
//                         </div>
//                       </div>
